// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */
.site-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
  background-color: var(--header-background-color);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.site-logo {
  width: 160px;
  height: auto;
}

.header-text {
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  padding-top: 5px;
}

.header-text h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-color);
}

.header-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-center h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-color);
  white-space: nowrap;
}


.model-icon {
  height: 50px;
  width: auto;
  margin-left: 10px;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle; /* ✅ Keeps it aligned with text baseline */
}


.theme-toggle {
  cursor: pointer;
}

.theme-toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  border-radius: 12px;
  background: linear-gradient(to right, #FFF4E0, #FFE8CC);
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
}

.theme-toggle-switch:before {
  content: '☀️';
  position: absolute;
  top: 2.5px;
  left: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: transform 0.3s ease, background-color 0.3s ease;
  color: black;
}

.theme-toggle-switch:after {
  position: absolute;
  top: 8px;
  left: 28px;
  font-size: 6px;
  color: rgba(255, 255, 255, 0.8);
  opacity: 1;
  transition: opacity 0.3s ease;
}

[data-theme='dark'] .theme-toggle-switch {
  background: linear-gradient(to right, #334, #223);
}

[data-theme='dark'] .theme-toggle-switch:before {
  content: '🌙';
  transform: translateX(26px);
  background-color: transparent;
  color: white;
}

[data-theme='dark'] .theme-toggle-switch:after {
  font-size: 8px;
  left: 6px;
  top: 4px;
  color: rgba(255, 255, 255, 0.7);
}


.header-buttons {
  display: flex;
  align-items: center;
  gap: 10px; 
}

.back-to-dashboard-button {
background-color: var(--primary-color); 
color: var(--button-text-color); 
border: none;
border-radius: 10px;
padding: 10px 20px; 
font-size: 14px;
font-weight: bold; 
cursor: pointer;
transition: background-color 0.3s ease, transform 0.2s ease;
box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); 
}

/* Hover effect */
.back-to-dashboard-button:hover {
background-color: var(--hover-color); 
transform: translateY(-2px); 
box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15); 
}

/* Active state */
.back-to-dashboard-button:active {
background-color: var(--active-color); 
transform: translateY(0);
box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); 
}

/* Light Mode Variables */
[data-theme='light'] {
--primary-color: #4a90e2;
--hover-color: #357ab8; 
--active-color: #2b5a8a; 
--button-text-color: white; 
}

/* Dark Mode Variables */
[data-theme='dark'] {
--primary-color: #3b5998; 
--hover-color: #2d4373; 
--active-color: #1e3050; 
--button-text-color: #eaeaea; 
}

.back-to-dashboard-button:disabled {
pointer-events: none;    /* Prevent clicks */
opacity: 0.5;            /* Dim the button visually */
cursor: not-allowed;     /* Show a blocked cursor */
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Header.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB,EAAE,0CAA0C;AACpE;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,+BAA+B;EAC/B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,QAAQ;EACR,+BAA+B;AACjC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;AACA,sCAAsC;AACtC,+BAA+B;AAC/B,YAAY;AACZ,mBAAmB;AACnB,kBAAkB;AAClB,eAAe;AACf,iBAAiB;AACjB,eAAe;AACf,2DAA2D;AAC3D,0CAA0C;AAC1C;;AAEA,iBAAiB;AACjB;AACA,oCAAoC;AACpC,2BAA2B;AAC3B,2CAA2C;AAC3C;;AAEA,iBAAiB;AACjB;AACA,qCAAqC;AACrC,wBAAwB;AACxB,0CAA0C;AAC1C;;AAEA,yBAAyB;AACzB;AACA,wBAAwB;AACxB,sBAAsB;AACtB,uBAAuB;AACvB,0BAA0B;AAC1B;;AAEA,wBAAwB;AACxB;AACA,wBAAwB;AACxB,sBAAsB;AACtB,uBAAuB;AACvB,4BAA4B;AAC5B;;AAEA;AACA,oBAAoB,KAAK,mBAAmB;AAC5C,YAAY,aAAa,4BAA4B;AACrD,mBAAmB,MAAM,0BAA0B;AACnD","sourcesContent":["/* Header.css */\r\n.site-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 30px;\r\n  background-color: var(--header-background-color);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.site-logo {\r\n  width: 160px;\r\n  height: auto;\r\n}\r\n\r\n.header-text {\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  text-align: center;\r\n  padding-top: 5px;\r\n}\r\n\r\n.header-text h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: var(--text-color);\r\n}\r\n\r\n.header-center {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.header-center h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: var(--text-color);\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n.model-icon {\r\n  height: 50px;\r\n  width: auto;\r\n  margin-left: 10px;\r\n  object-fit: contain;\r\n  display: inline-block;\r\n  vertical-align: middle; /* ✅ Keeps it aligned with text baseline */\r\n}\r\n\r\n\r\n.theme-toggle {\r\n  cursor: pointer;\r\n}\r\n\r\n.theme-toggle-switch {\r\n  position: relative;\r\n  width: 50px;\r\n  height: 24px;\r\n  border-radius: 12px;\r\n  background: linear-gradient(to right, #FFF4E0, #FFE8CC);\r\n  transition: background 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.theme-toggle-switch:before {\r\n  content: '☀️';\r\n  position: absolute;\r\n  top: 2.5px;\r\n  left: 4px;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background-color: transparent;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  transition: transform 0.3s ease, background-color 0.3s ease;\r\n  color: black;\r\n}\r\n\r\n.theme-toggle-switch:after {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 28px;\r\n  font-size: 6px;\r\n  color: rgba(255, 255, 255, 0.8);\r\n  opacity: 1;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n[data-theme='dark'] .theme-toggle-switch {\r\n  background: linear-gradient(to right, #334, #223);\r\n}\r\n\r\n[data-theme='dark'] .theme-toggle-switch:before {\r\n  content: '🌙';\r\n  transform: translateX(26px);\r\n  background-color: transparent;\r\n  color: white;\r\n}\r\n\r\n[data-theme='dark'] .theme-toggle-switch:after {\r\n  font-size: 8px;\r\n  left: 6px;\r\n  top: 4px;\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n\r\n.header-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px; \r\n}\r\n\r\n.back-to-dashboard-button {\r\nbackground-color: var(--primary-color); \r\ncolor: var(--button-text-color); \r\nborder: none;\r\nborder-radius: 10px;\r\npadding: 10px 20px; \r\nfont-size: 14px;\r\nfont-weight: bold; \r\ncursor: pointer;\r\ntransition: background-color 0.3s ease, transform 0.2s ease;\r\nbox-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); \r\n}\r\n\r\n/* Hover effect */\r\n.back-to-dashboard-button:hover {\r\nbackground-color: var(--hover-color); \r\ntransform: translateY(-2px); \r\nbox-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15); \r\n}\r\n\r\n/* Active state */\r\n.back-to-dashboard-button:active {\r\nbackground-color: var(--active-color); \r\ntransform: translateY(0);\r\nbox-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); \r\n}\r\n\r\n/* Light Mode Variables */\r\n[data-theme='light'] {\r\n--primary-color: #4a90e2;\r\n--hover-color: #357ab8; \r\n--active-color: #2b5a8a; \r\n--button-text-color: white; \r\n}\r\n\r\n/* Dark Mode Variables */\r\n[data-theme='dark'] {\r\n--primary-color: #3b5998; \r\n--hover-color: #2d4373; \r\n--active-color: #1e3050; \r\n--button-text-color: #eaeaea; \r\n}\r\n\r\n.back-to-dashboard-button:disabled {\r\npointer-events: none;    /* Prevent clicks */\r\nopacity: 0.5;            /* Dim the button visually */\r\ncursor: not-allowed;     /* Show a blocked cursor */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
